import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const VerifyMessage = styled.h2`
  color: ${ColorPalette.HEX.Manatee};
  font-size: 18px;
  line-height: 24px;
  font-weight: normal;
  margin-bottom: 32px;

  & > span {
    color: ${ColorPalette.HEX.CharlestonGreen};
    font-size: 24px;
    line-height: 32px;
  }
`;
